/**
 * Get the root HTML element.
 * @returns The root HTML element or undefined if not found.
 */
export const getRootElement = (): HTMLElement | undefined => document.documentElement;

/**
 * Set an attribute on an element.
 * @param element The element to set the attribute on.
 * @param attribute The name of the attribute to set.
 * @param value The value of the attribute to set.
 */
export const setAttribute = (element: Element | undefined, attribute: string, value: string) => {
    if (element && attribute && value) {
        element.setAttribute(attribute, value);
    }
};
